/*
 * @Author: maqyf
 * @Date: 2022-10-13 14:15:59
 * @LastEditors: maqyf
 * @LastEditTime: 2022-10-13 14:15:59
 * @Description: IconButton
 */

import React, { Component } from 'react';
import Button from '../Button';
import ToolTip from '../Tooltip';
import classNames from 'classnames';
import HotKeys from '../HotKeys';
import './index.less';

export default class IconButton extends Component {
    render() {
        let { title, btncolor, disabled = false, btnCode, icon, btnicon, type, showTip = true, onClick = ()=>{}, noBorder, className='', keyMap = {}, handlers = {} } = this.props;
        let key = btnCode;
        let item = { title, btncolor, disabled, key, icon, btnicon, type };
        return (
            <HotKeys
                keyMap={keyMap}
                handlers={handlers}
                className="dragwidth-hotkeys-wrapper"
                focused={true}
                attach={document.body}
                display="inline"
            >
                <ToolTip
                    placement="top"
                    inverse
                    overlay={showTip ? title : ''}
                    delayShow={500}>
                    <Button
                        disabled={disabled}
                        className={
                            classNames(
                                { 'button-primary': btncolor == 'button_main' }, 
                                'refresh-component',
                                'icon-button-wrapper',
                                { 'button-no-border': noBorder },
                                className,
                            )}
                        onClick={() => onClick({
                            key: key,
                            title: title,
                            item,
                        })
                        }
                        fieldid={key}
                        btn-code={key}
                    >
                        <i className={`iconfont ${icon || btnicon}`} />
                        { type === 'icon_title_btn' ? <span className='icon_title'>{title}</span> : null}
                    </Button>
                </ToolTip>
            </HotKeys>
        );
    }
}